import { render, staticRenderFns } from "./node-cbox.vue?vue&type=template&id=78b293fa&scoped=true&"
import script from "./node-cbox.vue?vue&type=script&lang=js&"
export * from "./node-cbox.vue?vue&type=script&lang=js&"
import style0 from "./node-cbox.vue?vue&type=style&index=0&id=78b293fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b293fa",
  null
  
)

export default component.exports